import { createColumnHelper } from '@tanstack/react-table';

import { Item, Status } from 'types/items';

const col = createColumnHelper<Item>();

/**
 * Mirrors Items.view.tsx's renderStatus: 0 and 12 get table-specific labels
 * ('NEW'/'END') instead of the raw Status enum names ('OPEN'/'CLOSE').
 */
export const renderStatus = (status: number) => {
  if (status === 0) {
    return 'NEW';
  }

  if (status === 12) {
    return 'END';
  }

  return Status[status];
};

export const buildItemColumns = () => [
  col.accessor((item) => item?.sku?.name || '-', {
    id: 'skuName',
    header: 'SKU',
    minSize: 150,
  }),
  col.accessor((item) => item?.sku?.itemType || '-', {
    id: 'itemType',
    header: 'Type',
    minSize: 150,
  }),
  col.accessor((item) => item?.sku.size || '-', {
    id: 'size',
    header: 'Size (Oz)',
    minSize: 80,
    meta: { align: 'center' },
  }),
  col.accessor((item) => item?.washHub?.name || '-', {
    id: 'washHub',
    header: 'Origin Wash Hub',
    minSize: 200,
    size: 320,
  }),
  col.accessor((item) => renderStatus(item?.status), {
    id: 'status',
    header: 'Status',
    minSize: 110,
    meta: { align: 'center' },
  }),
  col.accessor((item) => item?.currentPackage || '-', {
    id: 'currentPackage',
    header: 'Last assigned package',
    minSize: 200,
    size: 320,
  }),
  col.accessor((item) => item?.currentVenue?.name || '-', {
    id: 'currentVenue',
    header: 'Last Venue',
    minSize: 150,
  }),
];
